import { useOs, useWindowEvent } from '@mantine/hooks';
import { IconSearch } from '@tabler/icons-react';
import {
  Group,
  Icon,
  Text,
  UnstyledButton,
  brand,
} from '@zorro/web/design-system';
import { useState } from 'react';

import { useAppLayout } from '../../AppLayoutContext';
import classNames from './AppLayoutHeaderSearch.module.scss';
import { type AppLayoutSearchModal } from './AppLayoutSearchModal';

export const AppLayoutHeaderSearch = () => {
  const os = useOs();
  const { isSearchOpen, toggleSearch } = useAppLayout();
  const [searchModalComp, setSearchModalComp] = useState<
    typeof AppLayoutSearchModal | null
  >(null);

  const loadAndOpenSearch = async () => {
    if (!searchModalComp) {
      const AppLayoutSearchModal = await import('./AppLayoutSearchModal');
      setSearchModalComp(() => AppLayoutSearchModal.AppLayoutSearchModal);
    }
    toggleSearch();
  };

  useWindowEvent('keydown', (event) => {
    if (event.key !== 'b') {
      return;
    }

    if (
      (os === 'macos' && event.metaKey) ||
      (os === 'windows' && event.ctrlKey)
    ) {
      toggleSearch();
    }
  });

  const SearchModal = searchModalComp;

  return (
    <>
      <UnstyledButton onClick={loadAndOpenSearch} classNames={classNames}>
        <Group gap="xs">
          <Icon icon={IconSearch} color={brand.zorroGray400} />
          <Text c="zorroGray.4">Search across Zorro...</Text>
        </Group>
      </UnstyledButton>
      {SearchModal && (
        <SearchModal isOpen={isSearchOpen} onClose={toggleSearch} />
      )}
    </>
  );
};
